
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_49096","data-name":"Group 49096","transform":"translate(-936 -338)"}},[_c('rect',{attrs:{"id":"_279a62921c91a93a31c51e0fbd715ae6","data-name":"279a62921c91a93a31c51e0fbd715ae6","width":"30","height":"30","rx":"5","transform":"translate(936 338)","fill":"#e6e5e6"}}),_c('g',{attrs:{"id":"picture","transform":"translate(940.606 342.916)","fill":"#bebebf"}},[_c('path',{attrs:{"id":"Path_1","data-name":"Path 1","d":"M17.2 0H3.969A3.973 3.973 0 000 3.969V17.2a3.973 3.973 0 003.969 3.969H17.2a3.973 3.973 0 003.967-3.969V3.969A3.973 3.973 0 0017.2 0zM3.969 2.646H17.2a1.323 1.323 0 011.323 1.323V17.2a1.316 1.316 0 01-.388.935l-7.7-7.7a3.528 3.528 0 00-4.988 0l-2.8 2.8V3.969a1.323 1.323 0 011.322-1.323z"}}),_c('circle',{attrs:{"id":"Ellipse_1","data-name":"Ellipse 1","cx":"2.195","cy":"2.195","r":"2.195","transform":"translate(11.485 4.452)"}})])])])
          )
        }
      }
    